/* eslint-disable react/prop-types */
import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

const DatenschutzPage = ({ data }) => {
  return (
    <Layout>
      <SEO title="Datenschutzrichtlinie" />
      <div
        style={{
          textAlign: "center",
          marginTop: "50px",
        }}
        dangerouslySetInnerHTML={{
          __html:
            data.contentfulFooter.datenschutzrichtlinie.childMarkdownRemark
              .html,
        }}
      ></div>
    </Layout>
  )
}

export const query = graphql`
  {
    contentfulFooter {
      datenschutzrichtlinie {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`

export default DatenschutzPage
